var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgWordCloudIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 74,
    height: 49,
    viewBox: "0 0 74 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 43.8125,
    y: 32.915,
    width: 5.87769,
    height: 36.4417,
    rx: 2,
    transform: "rotate(90 43.8125 32.915)",
    fill: "#3B82C9"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 44.9883,
    width: 5.87769,
    height: 16.4575,
    rx: 2,
    transform: "rotate(90 44.9883 0)",
    fill: "#8CBFFF"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 44.9883,
    y: 42.3193,
    width: 5.87769,
    height: 16.4575,
    rx: 2,
    transform: "rotate(90 44.9883 42.3193)",
    fill: "#2B6299"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 64.6484,
    y: 9.4043,
    width: 5.67501,
    height: 25.5376,
    rx: 2,
    transform: "rotate(90 64.6484 9.4043)",
    fill: "#3B82C9"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 73.1992,
    y: 21.1597,
    width: 5.87769,
    height: 10.5798,
    rx: 2,
    transform: "rotate(90 73.1992 21.1597)",
    fill: "#2B6299"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 10.8945,
    y: 21.1597,
    width: 5.87769,
    height: 10.5798,
    rx: 2,
    transform: "rotate(90 10.8945 21.1597)",
    fill: "#8CBFFF"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 68.4961,
    y: 32.915,
    width: 5.87769,
    height: 21.1597,
    rx: 2,
    transform: "rotate(90 68.4961 32.915)",
    fill: "#2B6299"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 35.582,
    y: 9.4043,
    width: 5.87769,
    height: 28.2129,
    rx: 2,
    transform: "rotate(90 35.582 9.4043)",
    fill: "#8CBFFF"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 59.0938,
    y: 18.8086,
    width: 10.5798,
    height: 44.6704,
    rx: 2,
    transform: "rotate(90 59.0938 18.8086)",
    fill: "#3B82C9"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWordCloudIcon);
export default __webpack_public_path__ + "static/media/word_cloud_icon.25eaff0e.svg";
export { ForwardRef as ReactComponent };